import { createGlobalStyle } from 'styled-components'
import UbuntuLight from '../assets/fonts/Ubuntu-Light.ttf'
import Ubuntu from '../assets/fonts/Ubuntu-Regular.ttf'
import UbuntuMedium from '../assets/fonts/Ubuntu-Medium.ttf'
import UbuntuBold from '../assets/fonts/Ubuntu-Bold.ttf'
import AirwaveRegular from '../assets/fonts/Airwave-Regular.ttf'

const theme = {
  // background: 'blue',
  slate: '#324855',
  slateDark: '#424e60',
  dark: '#0d1d30',
  warmGrey: '#9b9b9b',
  border: 'rgba(151, 151, 151, 0.28)',
  green: '#49c3aa',
  grey: 'rgba(0,0,0,0.05)',
  grey2: '#bdc6cf',
  grey3: '#1d2c3d',
  logo: '#888888',
  copyright: '#8d9ca4',
  innerHeight: '100vw',
}

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Airwave-Regular';
    font-style: normal;
    font-weight: normal;
    src: url(${AirwaveRegular});
  }
  @font-face {
    font-family: 'Ubuntu-Light';
    font-style: normal;
    font-weight: 300;
    src: url(${UbuntuLight});
  }
  @font-face {
    font-family: 'Ubuntu';
    font-style: normal;
    font-weight: 400;
    src: url(${Ubuntu});
  }
  @font-face {
    font-family: 'Ubuntu-Medium';
    font-style: normal;
    font-weight: 500;
    src:  url(${UbuntuMedium});
  }
  @font-face {
    font-family: 'Ubuntu-Bold';
    font-style: normal;
    font-weight: 700;
    src:  url(${UbuntuBold});
  }

html, body {
  width: 100%;
  height: 100%;
  ${'' /* scroll-behavior: smooth */}
}  

html {
  box-sizing: border-box;
}

*, *::before, *::after {
  box-sizing: inherit;
  margin: 0;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Ubuntu-Light';
  font-weight: 300;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: ${theme.background};
}

a {
  text-decoration: none;
  color: inherit;
}

.flex-container {
  display: flex;
  justify-content: center;
}

.container {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px; 
}

`
export { theme, GlobalStyle as default }
